import { IOption } from '@/models/feeds.model';
import { SupportedLocales } from '@/models/localization.model';

export enum FeedsFiltersFields {
  SLUG = 'slug',
  NAME = 'name',
  REGION_ID = 'region_ids',
  CATEGORIES = 'category_ids',
  ACTIVE = 'active',
  TYPE = 'type',
  GENERATION_TYPE = 'generation_type',
}

export enum FeedsFormFieldsNames {
  NAME = 'name',
  REGION_ID = 'region_id',
  CATEGORIES = 'category_ids',
  SLUG = 'slug',
  ACTIVE = 'active',
  LOCALE = 'locale',
  TYPE = 'type',
  STORE_IDS = 'store_ids',
  MIN_PRICE = 'min_price',
  MAX_PRICE = 'max_price',
  IN_STOCK_ONLY = 'in_stock_only',
  EXCLUDE_FROM_GENERAL = 'exclude_from_general',
  ALL_CATEGORIES = 'all_categories',
}

export type TFeedFormValues = {
  [FeedsFormFieldsNames.REGION_ID]: IOption[] | string[];
  [FeedsFormFieldsNames.CATEGORIES]: IOption[] | string[];
  [FeedsFormFieldsNames.SLUG]: string;
  [FeedsFormFieldsNames.ACTIVE]: boolean;
  [FeedsFormFieldsNames.TYPE]: string;
  [FeedsFormFieldsNames.STORE_IDS]?: IOption[] | string[];
  [FeedsFormFieldsNames.MIN_PRICE]?: number | null;
  [FeedsFormFieldsNames.MAX_PRICE]?: number | null;
  [FeedsFormFieldsNames.IN_STOCK_ONLY]?: boolean;
  [FeedsFormFieldsNames.EXCLUDE_FROM_GENERAL]?: boolean;
  [FeedsFormFieldsNames.ALL_CATEGORIES]?: boolean;
  [FeedsFormFieldsNames.LOCALE]?: Record<
    SupportedLocales,
    {
      [FeedsFormFieldsNames.NAME]?: string;
    }
  >;
};

export type TGetFeedsQuery = {
  [FeedsFiltersFields.SLUG]?: string;
  [FeedsFiltersFields.NAME]?: string;
  [FeedsFiltersFields.REGION_ID]?: string[];
  [FeedsFiltersFields.CATEGORIES]?: string[];
  [FeedsFiltersFields.ACTIVE]?: '0' | '1';
  [FeedsFiltersFields.TYPE]?: string;
  [FeedsFiltersFields.GENERATION_TYPE]?: 'per_partner' | 'general';
};
